













import { computed, defineComponent } from '@nuxtjs/composition-api';
import useCartCookie from '@shared/composables/useCartCookie';
import useUiState from '@shared/composables/useUiState';
import { UCAppHeaderItem, UCBadge } from '@shared/ui';
import { cartGetters } from '@unified-commerce/gpc-vue-storefront-shopify';

export default defineComponent({
  name: 'HeaderCart',
  components: { UCAppHeaderItem, UCBadge },
  setup() {
    const { toggleCartSidebar } = useUiState();
    const { cart } = useCartCookie();
    const quantity = computed(() => cartGetters.getTotalItems(cart.value));

    return {
      toggleCartSidebar,
      quantity,
    };
  },
});
